const STATIONS = [
  { key: 'guxian', aliases: ['古贤', '古贤水库', '古贤水利枢纽'], name: '古贤水利枢纽', lng: 110.4518, lat: 36.0662, levelBase: 612.8, inflowBase: 1280, outflowBase: 940, rainBase: 18, ntuBase: 18, demandBase: 420, supplyBase: 455 },
  { key: 'xuefeng', aliases: ['薛峰', '薛峰水库', '薛峰站', '薛峰水文站'], name: '薛峰水库', lng: 110.3093, lat: 35.5265, levelBase: 913.4, inflowBase: 186, outflowBase: 154, rainBase: 22, ntuBase: 16, demandBase: 78, supplyBase: 83 },
  { key: 'longmen', aliases: ['龙门', '龙门站', '龙门水文站'], name: '龙门水文站', lng: 110.3191, lat: 35.5372, levelBase: 405.6, inflowBase: 1040, outflowBase: 990, rainBase: 16, ntuBase: 20, demandBase: 160, supplyBase: 172 },
  { key: 'longtan', aliases: ['龙潭', '龙潭水库', '龙潭水文站'], name: '龙潭水库', lng: 108.8780, lat: 34.9037, levelBase: 486.3, inflowBase: 252, outflowBase: 218, rainBase: 15, ntuBase: 21, demandBase: 96, supplyBase: 91 },
  { key: 'dongzhuang', aliases: ['东庄', '东庄水库', '东庄水文站'], name: '东庄水库', lng: 108.4994, lat: 34.7379, levelBase: 796.1, inflowBase: 318, outflowBase: 286, rainBase: 13, ntuBase: 17, demandBase: 120, supplyBase: 132 },
  { key: 'zhangjiamao', aliases: ['张家卯', '张家卯监测点'], name: '张家卯监测点', lng: 109.5600, lat: 34.6474, levelBase: 552.7, inflowBase: 72, outflowBase: 65, rainBase: 20, ntuBase: 26, demandBase: 44, supplyBase: 39 },
  { key: 'yichuan', aliases: ['宜川', '宜川监测点'], name: '宜川监测点', lng: 110.1754, lat: 36.0564, levelBase: 598.4, inflowBase: 164, outflowBase: 147, rainBase: 19, ntuBase: 18, demandBase: 64, supplyBase: 68 },
  { key: 'hancheng', aliases: ['韩城', '韩城监测点'], name: '韩城监测点', lng: 110.4428, lat: 35.4768, levelBase: 421.2, inflowBase: 238, outflowBase: 221, rainBase: 14, ntuBase: 19, demandBase: 88, supplyBase: 93 },
]

const METRICS = [
  { key: 'level', aliases: ['水位', '库水位', '水深'], label: '水位', unit: 'm', panel: 'monitoring' },
  { key: 'inflow', aliases: ['入库', '来水', '入流', '入库流量'], label: '入库流量', unit: 'm³/s', panel: 'monitoring' },
  { key: 'outflow', aliases: ['出库', '下泄', '出流', '出库流量'], label: '出库流量', unit: 'm³/s', panel: 'monitoring' },
  { key: 'rain', aliases: ['降雨', '雨量', '降水'], label: '降雨量', unit: 'mm/h', panel: 'monitoring' },
  { key: 'waterQuality', aliases: ['水质', '浊度', '污染', 'ntu'], label: '水质浊度', unit: 'NTU', panel: 'monitoring' },
  { key: 'supplyDemand', aliases: ['供需', '缺额', '供水', '需水'], label: '供需平衡', unit: '万m³/d', panel: 'supplyDemand' },
]

function hash(input) {
  let value = 0
  for (let i = 0; i < input.length; i++) value = (value * 31 + input.charCodeAt(i)) % 9973
  return value
}

function wave(seed, index, amplitude = 1) {
  return Math.sin((index + seed) / 24 * Math.PI * 2) * amplitude
}

function round(value, digits = 1) {
  const base = Math.pow(10, digits)
  return Math.round(value * base) / base
}

export function findStation(text) {
  const lower = String(text || '').toLowerCase()
  return STATIONS.find(station => station.aliases.some(alias => lower.includes(alias.toLowerCase()))) || null
}

export function findMetric(text) {
  const lower = String(text || '').toLowerCase()
  return METRICS.find(metric => metric.aliases.some(alias => lower.includes(alias.toLowerCase()))) || null
}

export function parseMonitoringQuestion(text) {
  const station = findStation(text)
  const metric = findMetric(text)
  const asksData = /数据|多少|情况|汇报|监测|实时|当前|现在|查询|看一下|怎么样/.test(text)
  if (!station && !metric) return null
  if (!asksData && !metric) return null
  return buildMonitoringSnapshot(station || STATIONS[0], metric || METRICS[0])
}

export function buildMonitoringSnapshot(station, metric) {
  const seed = hash(`${station.key}-${metric.key}-${new Date().getHours()}`)
  const trend = round(wave(seed, 2, metric.key === 'level' ? 0.08 : 6), 2)
  const level = round(station.levelBase + wave(seed, 1, 0.42), 2)
  const inflow = Math.max(0, Math.round(station.inflowBase + wave(seed, 3, station.inflowBase * 0.12)))
  const outflow = Math.max(0, Math.round(station.outflowBase + wave(seed, 5, station.outflowBase * 0.10)))
  const rain = round(Math.max(0, station.rainBase + wave(seed, 7, 11)), 1)
  const ntu = round(Math.max(1, station.ntuBase + wave(seed, 9, 8)), 1)
  const demand = round(station.demandBase + wave(seed, 11, station.demandBase * 0.08), 1)
  const supply = round(station.supplyBase + wave(seed, 13, station.supplyBase * 0.07), 1)
  const deficit = round(Math.max(0, demand - supply), 1)

  const values = { level, inflow, outflow, rain, waterQuality: ntu, supplyDemand: supply }
  const current = values[metric.key]
  const status = getStatus(metric.key, { level, rain, ntu, deficit, inflow, outflow })

  return {
    station,
    metric,
    current,
    status,
    trend,
    time: new Date().toLocaleString('zh-CN', { hour12: false }),
    values: { level, inflow, outflow, rain, ntu, demand, supply, deficit },
  }
}

export function createMonitoringSeries(snapshot) {
  const { station } = snapshot
  const seed = hash(`${station.key}-${snapshot.metric.key}`)
  const times = []
  const inflow = []
  const outflow = []
  const reservoirLevel = []

  for (let i = 23; i >= 0; i--) {
    const d = new Date(Date.now() - i * 3600 * 1000)
    times.push(`${String(d.getHours()).padStart(2, '0')}:00`)
  }

  for (let i = 0; i < 24; i++) {
    const inVal = Math.max(10, Math.round(station.inflowBase + wave(seed, i, station.inflowBase * 0.16) + wave(seed, i * 2, station.inflowBase * 0.04)))
    const outVal = Math.max(8, Math.round(station.outflowBase + wave(seed + 5, i, station.outflowBase * 0.12)))
    const levelVal = round(station.levelBase + wave(seed + 2, i, 0.55) + (inVal - outVal) / Math.max(station.inflowBase, 1) * 0.08, 2)
    inflow.push(inVal)
    outflow.push(outVal)
    reservoirLevel.push(levelVal)
  }

  const allocationValues = [
    Math.round(station.demandBase * 0.46),
    Math.round(station.demandBase * 0.22),
    Math.round(station.demandBase * 0.18),
    Math.round(station.demandBase * 0.10),
    Math.round(station.demandBase * 0.04),
  ]
  const allocationPie = [
    { name: '古贤调水', value: 54 },
    { name: '本地蓄水', value: 22 },
    { name: '区间来水', value: 13 },
    { name: '再生水', value: 7 },
    { name: '雨洪利用', value: 4 },
  ]

  return { times, inflow, outflow, reservoirLevel, allocationValues, allocationPie }
}

export function formatMonitoringReply(snapshot) {
  const { station, metric, values } = snapshot
  if (metric.key === 'supplyDemand') {
    const balance = values.deficit > 0 ? `存在 ${values.deficit} 万m³/d 缺额` : `盈余 ${round(values.supply - values.demand, 1)} 万m³/d`
    return `${station.name}供需平衡：可供水量 ${values.supply} 万m³/d，需水量 ${values.demand} 万m³/d，${balance}；已打开供需平衡面板并生成演示数据。`
  }
  const extra = `入库 ${values.inflow} m³/s，出库 ${values.outflow} m³/s，降雨 ${values.rain} mm/h，水质浊度 ${values.ntu} NTU`
  return `${station.name}${metric.label}实时值为 ${snapshot.current} ${metric.unit}，状态${snapshot.status}，较上一小时${snapshot.trend >= 0 ? '上升' : '下降'} ${Math.abs(snapshot.trend)}；${extra}。已切换到该站点监控面板。`
}

function getStatus(metricKey, values) {
  if (metricKey === 'rain') return values.rain >= 50 ? '橙色预警' : values.rain >= 25 ? '关注' : '正常'
  if (metricKey === 'waterQuality') return values.ntu >= 50 ? '超标预警' : values.ntu >= 30 ? '关注' : '正常'
  if (metricKey === 'supplyDemand') return values.deficit > 0 ? '缺额预警' : '平衡'
  if (metricKey === 'level') return '正常蓄水区间'
  return values.inflow >= values.outflow ? '来水充足' : '平稳'
}
